export const QUESTIONS = [
  {
    id: 1,
    category: "GED",
    title: "Gestion Documentaire (GED)",
    question: "À quelle fréquence vos équipes sont-elles ralenties par la recherche d'une information ou d'un document ?",
    icon: "FileSearch",
    options: [
      {
        label: "A",
        text: "Jamais. Tout est centralisé, indexé et accessible en 2 clics (même à distance)",
        points: 20,
        gain_minutes: 0
      },
      {
        label: "B",
        text: "Souvent. On perd du temps à fouiller dans les emails, les serveurs ou les dossiers papier.",
        points: 10,
        gain_minutes: 15
      },
      {
        label: "C",
        text: "Systématiquement. C'est un point de frustration majeur qui génère des erreurs et des retards.",
        points: 0,
        gain_minutes: 40
      }
    ]
  },
  {
    id: 2,
    category: "Print",
    title: "Système d'Impression (Print)",
    question: "Comment décririez-vous la gestion de vos impressions au quotidien ?",
    icon: "Printer",
    options: [
      {
        label: "A",
        text: "Fluide et maîtrisée : badges sécurisés, consommables automatiques, zéro panne bloquante.",
        points: 20,
        gain_minutes: 0
      },
      {
        label: "B",
        text: "Manuelle : Plusieurs imprimantes, on gère les stocks nous-mêmes, et les pannes ralentissent parfois le service.",
        points: 10,
        gain_minutes: 10
      },
      {
        label: "C",
        text: "Chaotique : coûts inconnus, pannes fréquentes, aucune règle de sécurité",
        points: 0,
        gain_minutes: 20
      }
    ]
  },
  {
    id: 3,
    category: "Cybersécurité",
    title: "Sécurité informatique",
    question: "Quel est le niveau de protection de votre parc informatique ?",
    icon: "Shield",
    options: [
      {
        label: "A",
        text: "Politique complète : sauvegardes, antivirus à jour, équipe sensibilisée",
        points: 20,
        gain_minutes: 0
      },
      {
        label: "B",
        text: "Protection de base, pas de politique formalisée ni de plan de reprise",
        points: 10,
        gain_minutes: 15
      },
      {
        label: "C",
        text: "Peu ou pas de protection — je sais que c'est risqué mais rien n'est fait",
        points: 0,
        gain_minutes: 30
      }
    ]
  },
  {
    id: 4,
    category: "Réseau",
    title: "Réseau & téléphonie",
    question: "Comment décririez-vous votre infrastructure réseau et téléphonie ?",
    icon: "Network",
    options: [
      {
        label: "A",
        text: "Réseau performant, téléphonie IP, télétravail et mobilité fluides",
        points: 20,
        gain_minutes: 0
      },
      {
        label: "B",
        text: "Réseau correct mais téléphonie classique, mobilité limitée",
        points: 10,
        gain_minutes: 10
      },
      {
        label: "C",
        text: "Coupures fréquentes, mauvaise couverture, pas de solution unifiée",
        points: 0,
        gain_minutes: 20
      }
    ]
  },
  {
    id: 5,
    category: "Formation",
    title: "Maîtrise des logiciels",
    question: "Vos équipes maîtrisent-elles bien leurs outils métier (Sage, EBP, Excel…) ?",
    icon: "GraduationCap",
    options: [
      {
        label: "A",
        text: "Oui, formation à jour — outils pleinement exploités, aucune perte de temps",
        points: 20,
        gain_minutes: 0
      },
      {
        label: "B",
        text: "Utilisation basique — quelques lacunes génèrent des erreurs et ressaisies",
        points: 10,
        gain_minutes: 20
      },
      {
        label: "C",
        text: "Formations insuffisantes — beaucoup de temps perdu sur les outils",
        points: 0,
        gain_minutes: 40
      }
    ]
  }
];

export const formatGain = (minutes) => {
  const hours = Math.floor(minutes / 60);
  const mins = minutes % 60;
  return `${hours}h${mins.toString().padStart(2, '0')}`;
};

export const getBadge = (score) => {
  if (score >= 80) return { label: '✅ Performeur Fluide', color: '#2E7D32', bg: '#E8F5E9' };
  if (score >= 50) return { label: '⚠️ En Transition', color: '#F9A825', bg: '#FFF9E6' };
  return { label: '❌ En Surcharge', color: '#C62828', bg: '#FFEBEE' };
};

export const getAgency = (postalCode) => {
  const prefix = String(postalCode).substring(0, 2);
  if (['87', '23', '19'].includes(prefix)) return 'limoges';
  if (['86', '79', '17'].includes(prefix)) return 'poitiers';
  if (['33', '24', '40'].includes(prefix)) return 'bordeaux';
  return 'siege';
};
